import React from "react";
import { Box, Typography, Stack, Avatar } from "@mui/material";
import { Images } from "../../assets/common";
import { isOwner, isOwnerId } from "./../../constants/function";
import MusicCard from "../MusicCard";
import "./index.scss";
export default function MusicList({
  music,
  isArtist,
  isPlaylist,
  isMusic,
  actions,
  toggleMenu,
  isNft,
  isFeature,
  ownerRoyalty,
  isPlaylistNft,
  playSongs,
  isHome,
  hideIcons,
  platform,
  isStreaming,
  onStream,
}) {
  return (
    <>
      <Stack
        direction="row"
        spacing={3}
        sx={{ marginTop: "16px", maxWidth: "100vw", overflowY: "scroll" }}
        className="__feature__"
      >
        {music &&
          music.map((col, index) => (
            <MusicCard
              isStreaming={isStreaming}
              platform={col.platform}
              hideIcons={hideIcons}
              songIndex={index}
              playSongs={playSongs}
              isHome={isHome}
              isPlaylist={isPlaylist}
              isArtist={isArtist}
              music={col}
              key={`${col["_id"]}${index}`}
              isMusic={isMusic}
              cardIndex={index}
              isNft={col.nftId ? true : isNft}
              isFeature={isFeature}
              ownerRoyalty={ownerRoyalty}
              isPlaylistNft={
                (isPlaylist && col.nftId) || isStreaming ? true : false
              }
              actions={
                isPlaylist
                  ? [
                      "Add all songs to Queue",
                      typeof col["creatorId"] === "string" ||
                      typeof col["uploader"] === "string"
                        ? isOwnerId(
                            col["creatorId"]
                              ? col["creatorId"]
                              : col["uploader"]
                          )
                        : isOwner(
                            isMusic
                              ? col["owner"]["email"]
                              : isArtist
                              ? col["email"]
                              : col["createdBy"]["email"]
                          )
                        ? `Mark this Asset ${
                            col["private"] ? "Public" : "Private"
                          }`
                        : "",
                      "View Statistics",
                    ]
                  : actions
              }
              toggleMenu={(action, id) => toggleMenu(action, id, index)}
              onStream={(channelName) => onStream(channelName)}
            />
          ))}
      </Stack>
    </>
  );
}
